export default {
    "save_book_limitation_warning_unsubscribed_user":"You have exceeded your limit for saving books for free. Please subscribe to save more books.",
    "save_book_limitation_warning_subscribed_user":"You have maximized your limit.",
}